export default __webpack_public_path__ + "static/taskdef3-cfbc51e6a060b82a829dc88bfc6447ad.png";